import { render, staticRenderFns } from "./EditWorkplaces.vue?vue&type=template&id=3b6d18e6"
import script from "./EditWorkplaces.vue?vue&type=script&lang=ts"
export * from "./EditWorkplaces.vue?vue&type=script&lang=ts"
import style0 from "./EditWorkplaces.vue?vue&type=style&index=0&id=3b6d18e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports